import React, { useContext } from 'react';

import { Link as RouterLink } from 'react-router-dom';

import {
    Autocomplete,
    Box,
    Card,
    CardContent,
    CardHeader,
    Checkbox,
    Divider,
    Grid,
    Link,
    Table,
    TableBody,
    TableCell,
    TableRow,
    TextField,
    Typography
} from '@mui/material';

import { TreeItem, TreeView } from '@mui/lab';

import { ArrowDropDown, ArrowRight, } from '@mui/icons-material';
import RoomIcon from '@mui/icons-material/Room';

import { UtenteContext } from '../UtenteContext';

import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Field, Formik } from 'formik';
import moment from "moment/moment";
import * as Yup from 'yup';
import { ValoreRuoli } from "../../../../helpers/Common";
import { DateTableRow, UtenteTableRow } from '../../../common';

const LinkRouter = props => <Link {...props} component={RouterLink} />;

const UtenteSchema = Yup.object().shape({
    nome: Yup.string().required("Il nome è un campo obbligatorio"),
    cognome: Yup.string().required("Il congnome è un campo obbligatorio"),
    codiceFiscale: Yup.string().required("Il codice fiscale è un campo obbligatorio"),
    ruoloId: Yup.number().required("Il ruolo è un campo obbligatorio"),
});

export const UtenteDetails = ({
    disabled,
    formRef,
    onActionClick,
    ...props
}) => {

    const {
        state,
        setState,
    } = useContext(UtenteContext);

    const {
        utente,
        ruoli,
        ruoliOptions,
        tipi,
    } = state;

    const handleOnSubmit = async (values) => {
        if (onActionClick)
            if (onActionClick)
                onActionClick("Submit", values);
    }

    const getAllTipiUfficiTreeIds = (tipiUffici, padreId = null) => {
        var tipiUfficiIds = tipiUffici.filter(x => x.padreId == padreId)?.map(x => x.id);
        if (tipiUfficiIds && tipiUfficiIds.length > 0) {
            var tempTipiUfficiIds = [];
            tipiUfficiIds.forEach(x => tempTipiUfficiIds = [...tempTipiUfficiIds, ...getAllTipiUfficiTreeIds(tipiUffici, x)]);
        }
        if (tempTipiUfficiIds?.length > 0)
            tipiUfficiIds = [...tipiUfficiIds, ...tempTipiUfficiIds]
        return tipiUfficiIds;
    }

    function onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }

    const renderTipiUfficiList = (tipiUffici, setFieldValue, values, padreId = null) => {

        if (tipiUffici.filter(x => x.padreId == padreId).some(x => x.competenza)) {
            tipiUffici = tipiUffici.sort((a, b) => a.competenza?.ordine.localeCompare(b.competenza?.ordine));
        } else {
            tipiUffici = tipiUffici.sort((a, b) => a.nome.localeCompare(b.nome));
        }

        return tipiUffici
            .filter(x => x.padreId == padreId)
            .map(tipoUfficio => {
                return <TreeItem
                    key={tipoUfficio.id}
                    nodeId={`${tipoUfficio.id}`}
                    label={
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                {
                                    tipoUfficio.urlIcona ?
                                        <img width={24} src={tipoUfficio.urlIcona} />
                                        :
                                        <RoomIcon />
                                }
                                <Typography fontSize={14} marginLeft={1}>
                                    {tipoUfficio.nome}
                                </Typography>
                            </Box>
                            <Checkbox
                                checked={values.tipiUfficiIds.some(x => x == tipoUfficio.id)}
                                onClick={e => {
                                    e.stopPropagation();
                                    if (e.target.checked) {
                                        var temp = [...values.tipiUfficiIds, ...getAllTipiUfficiTreeIds(tipi.result, tipoUfficio.id), tipoUfficio.id];
                                        temp = temp.filter(onlyUnique);
                                        setFieldValue("tipiUfficiIds", temp);
                                    } else {
                                        var temp = [...getAllTipiUfficiTreeIds(tipi.result, tipoUfficio.id), tipoUfficio.id];
                                        temp = temp.filter(onlyUnique);
                                        setFieldValue("tipiUfficiIds", values.tipiUfficiIds.filter(x => !temp.some(y => y == x)));
                                    }
                                }}
                                sx={{ marginRight: 1, padding: 0.5 }}
                            />
                        </Box>
                    }>
                    {tipiUffici.some(x => x.padreId == tipoUfficio.id) ? renderTipiUfficiList(tipiUffici, setFieldValue, values, tipoUfficio.id) : null}
                </TreeItem>
            })
    }

    return (
        <>
            <Formik
                innerRef={formRef}
                initialValues={
                    {
                        nome: utente?.nome ?? "",
                        cognome: utente?.cognome ?? "",
                        codiceFiscale: utente?.codiceFiscale ?? "",
                        ruoloId: utente?.ruoloId,
                        tipiUfficiIds: utente?.utenteTipiUffici?.map(x => x.tipoUfficioId) ?? [],
                        inizioValidita: utente?.inizioValidita ?? moment.utc([1946, 5, 2]),
                        fineValidita: utente?.fineValidita ?? null,
                    }
                }
                enableReinitialize
                validationSchema={UtenteSchema}
                onSubmit={handleOnSubmit}
            >
                {({
                    values,
                    handleSubmit,
                    setFieldValue,
                    errors,
                    touched,
                    setTouched,
                    handleChange,
                }) => {
                    return <form onSubmit={handleSubmit}>
                        <Grid container spacing={2} sx={{ marginTop: 2 }}>
                            <Grid item xs={12}>
                                <Card>
                                    <CardHeader
                                        sx={{
                                            color: "white",
                                            backgroundColor: "secondary.main",
                                        }}
                                        title={
                                            <Grid container alignItems="center" justify="space-between">
                                                <Grid item>
                                                    <Typography variant="h6">Informazioni</Typography>
                                                </Grid>
                                            </Grid>
                                        }
                                    />
                                    <Divider />
                                    <CardContent sx={{ padding: "0px !important" }}>
                                        <Table>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Nome
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="nome"
                                                            name="nome"
                                                            value={values.nome}
                                                            onChange={handleChange}
                                                            error={touched.nome && Boolean(errors.nome)}
                                                            helperText={touched.nome && errors.nome}
                                                            inputProps={{ sx: { padding: 1 } }} />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Cognome
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="cognome"
                                                            name="cognome"
                                                            value={values.cognome}
                                                            onChange={handleChange}
                                                            error={touched.cognome && Boolean(errors.cognome)}
                                                            helperText={touched.cognome && errors.cognome}
                                                            inputProps={{ sx: { padding: 1 } }} />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Codice fiscale
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="codiceFiscale"
                                                            name="codiceFiscale"
                                                            value={values.codiceFiscale}
                                                            onChange={handleChange}
                                                            error={touched.codiceFiscale && Boolean(errors.codiceFiscale)}
                                                            helperText={touched.codiceFiscale && errors.codiceFiscale}
                                                            inputProps={{ sx: { padding: 1 } }} />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Ruolo
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="ruoloId"
                                                            component={Autocomplete}
                                                            options={ruoliOptions}
                                                            onChange={(e, value) => {
                                                                setFieldValue('ruoloId', value?.ruoloId)
                                                            }}
                                                            value={ruoliOptions.find(option => option.ruoloId == values.ruoloId) ?? null}
                                                            renderInput={(params) => <TextField {...params}
                                                                label="Scegli..." />}
                                                            fullWidth
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                {
                                                    ruoli?.result.find(x => x.id == values.ruoloId)?.valoreRuolo == ValoreRuoli.Redattore &&
                                                    <TableRow>
                                                        <TableCell style={{ width: "20%" }}>
                                                            Tipi uffici
                                                        </TableCell>
                                                        <TableCell>
                                                            <TreeView
                                                                sx={{ paddingRight: '16px', }}
                                                                defaultCollapseIcon={<ArrowDropDown />}
                                                                defaultExpandIcon={<ArrowRight />}>
                                                                {
                                                                    renderTipiUfficiList(tipi?.result ?? [], setFieldValue, values)
                                                                }
                                                            </TreeView>
                                                        </TableCell>
                                                    </TableRow>
                                                }
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Inizio validità
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="inizioValidita"
                                                            component={DatePicker}
                                                            onChange={value => {
                                                                if (value?.isValid)
                                                                    setFieldValue('inizioValidita', moment.utc([value.year(), value.month(), value.date()]))
                                                                else
                                                                    setFieldValue('inizioValidita', null);
                                                            }}
                                                            inputFormat="DD/MM/YYYY"
                                                            minDate={moment.utc([1946, 5, 2])}
                                                            value={values.inizioValidita}
                                                            renderInput={(params) => <TextField {...params} />}
                                                            fullWidth
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Fine validità
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="fineValidita"
                                                            component={DatePicker}
                                                            onChange={value => {
                                                                if (value?.isValid)
                                                                    setFieldValue('fineValidita', moment.utc([value.year(), value.month(), value.date()]))
                                                                else
                                                                    setFieldValue('fineValidita', null);
                                                            }}
                                                            inputFormat="DD/MM/YYYY"
                                                            minDate={moment.utc([1946, 5, 2])}
                                                            value={values.fineValidita}
                                                            renderInput={(params) => <TextField {...params} />}
                                                            fullWidth
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <UtenteTableRow label={'Creato da'} utenteId={utente?.creatoDa} />
                                                <DateTableRow label={'Data creazione'} stringDate={utente?.dataCreazione} />
                                                <UtenteTableRow label={'Ultima modifica da'} utenteId={utente?.aggiornatoDa} />
                                                <DateTableRow label={'Data ultima modifica'} stringDate={utente?.dataAggiornamento} />
                                            </TableBody>
                                        </Table>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </form>
                }}
            </Formik>
        </>
    );
}